import React from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";

import {
  buildRedirectTarget,
  getLoginPathWithRedirect,
  isAuthenticated,
} from "helpers/authSession";
import DashboardLayout from "shared/DashboardLayout/DashboardLayout";

const RequireAuth = () => {
  const location = useLocation();

  if (!isAuthenticated()) {
    return (
      <Navigate
        to={getLoginPathWithRedirect(
          buildRedirectTarget(location.pathname, location.search)
        )}
        replace
      />
    );
  }

  return (
    <DashboardLayout>
      <Outlet />
    </DashboardLayout>
  );
};

export default RequireAuth;
